import UltMeta, { Meta } from "./UltMeta/index";

class TonnageType extends UltMeta {
    SIX_TO_NINE_THOUSAND_PRICE = new Meta(1, "6千吨到9千吨位");
    TEN_THOUSAND_PRICE = new Meta(2, "1万吨位");
    FIFTEEN_UP_THOUSAND_PRICE = new Meta(3, "1.5万+吨位");
}

export const TONNAGE_TYPE = new TonnageType();

class PublishType extends UltMeta {
    MANUAL = new Meta(1, "手动发布");
    AUTOMATIC = new Meta(2, "自动发布");
}

export const PUBLISH_TYPE = new PublishType();
